import React, { useEffect, useState } from "react";
import "../styles/Blogs.css";
const Blogs = () => {
  const mediumURL =
    "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@Keyur_G_Kulkarni";
  const [profile, setProfile] = useState({
    name: "Keyur G Kulkarni",
    profileImage: "",
    profileUrl: "",
  });
  const [blog, setBlog] = useState({
    item: [],
    isLoading: true,
    error: null,
  });
  useEffect(() => {
    fetch(mediumURL)
      .then((res) => res.json())
      .then((info) => {
        const image = info.feed.image;
        const link = info.feed.link;
        const blogs = info.items;
        const posts = blogs.filter((post) => post.categories.length > 0);
        setProfile((p) => ({ ...p, profileUrl: link, profileImage: image }));
        setBlog({ item: posts, isLoading: false });
      })
      .catch((err) => setBlog({ error: err.message }));
  }, []);

  const ToText = (node) => {
    let tag = document.createElement("div");
    tag.innerHTML = node;
    return tag.innerText;
  };

  const haveBlogs = () => {
    if (blog.item) {
      const latestPosts = blog.item.slice(0, 3); // Get the latest 3 posts
      return latestPosts.map((post, index) => (
        <div key={index} className="blog-box">
          <div
            className="thumbnail"
            style={{ backgroundImage: `url(${post.thumbnail})` }}
          ></div>
          <div className="author-title">
            <div className="author-image">
              <a href={profile.profileUrl}>
                <img src={profile.profileImage} alt="Author" />
              </a>
            </div>
            <div className="card-title">
              <h5 className="postTitle">
                <a href={post.link}>{post.title}</a>
              </h5>
            </div>
          </div>
          <div className="card-body">
            <p className="blog-description">{`${ToText(
              post.description.substring(0, 300)
            )}...`}</p>
          </div>
        </div>
      ));
    }
  };

  return (
    <div className="blog-container">
      <h2>Blogs</h2>
      <div className="blogs">{blog.isLoading ? "Loading..." : haveBlogs()}</div>
    </div>
  );
};

export default Blogs;
